module.exports = __webpack_public_path__ + "static/media/kongke.08402c4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/kongke.mp4
// module id = OZYm
// module chunks = 0